export default "__VITE_ASSET__DQCdF$st__"